import { Spin } from 'antd'
import React, { useContext } from 'react'
import { InterimPoolCreateStyle } from './styled'
import { ConfigContext } from '@/utils/contextStatic'
import Text from '@/components/Text'


const InterimPoolCreate:React.FC = ()=> {

	const { isPC }:any = useContext(ConfigContext)

	// 加载中
  const loaderRender = () => {
    return (
			<Spin size={isPC ? 'large' : 'default'} tip={<Text type='english' size={isPC ? '16' : '14'} color='gray600'>Loading...</Text>} >
				<i></i>
			</Spin>
		)
  }

  return (
		<InterimPoolCreateStyle>{loaderRender()}</InterimPoolCreateStyle>
  )
}

export default InterimPoolCreate
